import React from "react";
import "../../App.css";
import ProfileSection from "../ProfileSection";

function Home() {
  return (
    <>
      <ProfileSection />
    </>
  );
}

export default Home;
